import { useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import SectionDetails from '../../_Sections/SectionDetails';
import SectionGallery from '../../_Sections/SectionGallery';
import SectionDropship from '../../_Sections/SectionDropship';
import SectionPairings from '../../_Sections/SectionPairings';
import SectionBranding from '../../_Sections/SectionBranding';
import SectionSizes from '../../_Sections/SectionSizes';
import SectionPricing from '../../_Sections/SectionPricing';
import tKey from '../../../Common/Utils/tKey';
import { useAppSelector } from '../../../Common/_hooks/useAppSelector';
import ProductSEO from '../../_Sections/ProductSEO';

const PRODUCT_ID = 58;
const VIEW_PRODUCT_ID = 23;

export default function CaprisPage() {
  const [t] = useTranslation('page/products/yoga-capris');
  const productData = useAppSelector(state => state.get('appData').get('products').get(String(PRODUCT_ID)));
  const locale = useAppSelector(state => state.get('userData').get('prefs').get('lang'))

  if (!productData) return null

  return <div className="centered-page product-page-v4">
    <ProductSEO
      viewProductId={VIEW_PRODUCT_ID}
      title={t('Custom all-over print Yoga Capris | Products')}
      description={t('Design and create your own custom printed Yoga Capris. ✔ Print-on-demand drop shipping ✔ No minimums ✔ Made in Canada')}
    />
    <SectionDetails
      viewProductId={VIEW_PRODUCT_ID}
      color="#68a9f5"
      bgStyle={{
        backgroundPosition: 'center right',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '47%',
      }}
      tag={t('The all-over print')}
      title={t('Yoga Capris')}
      text={t('Flow freely in custom all-over print yoga capris made on-demand in Montreal. Designed with a wide, high-rise waistband and mid-calf length, they offer a sculpted, secure fit for movement and mindfulness. Made from ultrasoft Luxeform fabric, each pair features vibrant, permanent prints that stay brilliant pose after pose. ')}
      createUrl={productData.get('url_slug') + '?option_fabric=performance-knit'}
      img={require('@resources/img/pages/products/yoga-capris/banner-1-' + locale + '.png')}
      alt={t('Picture of Yoga Capris')}
      details={[
        {
          img: require('@resources/img/pages/products/yoga-capris/icon-1.svg?url'),
          alt: t('icon'),
          text: t('Body-hugging fit with wide, high-rise waistband'),
        },
        {
          img: require('@resources/img/pages/products/yoga-capris/icon-2.svg?url'),
          alt: t('icon'),
          text: t('Made from Luxeform performance fabric: combining the power of spandex with lightness and comfort'),
        },
        {
          img: require('@resources/img/pages/products/yoga-capris/icon-3.svg?url'),
          alt: t('icon'),
          text: t('Mid-calf length'),
        },
        {
          img: require('@resources/img/pages/products/yoga-capris/icon-4.svg?url'),
          alt: t('icon'),
          text: t('Vibrant, permanent prints won’t fade with use or washing'),
        },
        {
          img: require('@resources/img/pages/products/yoga-capris/icon-5.svg?url'),
          alt: t('icon'),
          text: t('Digitally printed on demand in Montreal, Canada'),
        },
      ]}
    />
    
    <SectionGallery images={[
      require('@resources/img/pages/products/yoga-capris/gallery_0.jpg'),
      require('@resources/img/pages/products/yoga-capris/gallery_1.jpg'),
      require('@resources/img/pages/products/yoga-capris/gallery_2.jpg'),
      require('@resources/img/pages/products/yoga-capris/gallery_3.jpg'),
      require('@resources/img/pages/products/yoga-capris/gallery_4.jpg'),
    ]} />

    <SectionDropship
      title={<Trans
        t={t}
        i18nKey={tKey('<yellow>Drop ship</yellow> your yoga capris<br/> <pink>on-demand</pink>')}
        components={{
          yellow: <span className="ty" />,
          pink: <span className="tp" />,
        }}
      />}
      text={t('Your brand and following will love Yoga Capris! At prices designed for reselling, Yoga Capris made on demand meet the needs of sellers who prefer not to stock inventory. Sell them in your eCommerce store and decide your profit margin.')}
    />

    <SectionPricing
      productId={PRODUCT_ID}
      options={['performance-knit']}
    />

    <SectionSizes
      chart="bottoms"
      productId={PRODUCT_ID}
      title={t('Yoga Capris Sizing')}
      text={t('There may be some variations in product measurements within or between orders. Each garment is individually cut and sewn which can lead to minor differences in measurements. Measurements are body measurements that correspond with the garment size in US standard sizing. For in between sizes, we recommend choosing the larger size.')}
    />

    <SectionBranding
      hasLabel
      title={t('Brand your Yoga Capris')}
      text={t('Branding enhances your products. Add custom labels, artist cards or stickers to your packages to create a cohesive message and build your brand.')}
    />

    <SectionPairings
      text={t('Pair your Yoga Capris with these great products to create your own unique styles.')}
      productSlugs={['cropped-pullover-hoodie', 'premium-unisex-tank-top', 'comfort-t-shirt']}
    />
  </div>
}